export const parseLiveblocksUser = (liveblocksUserId: string) => {
  const parts = liveblocksUserId.split(':');

  const type = parts[0];

  if (type === 'external') {
    const [, , userEmail] = parts;
    return {
      type,
      userName: userEmail,
      userEmail,
    };
  }

  if (type === 'internal') {
    const [, userId, userName, userEmail] = parts;
    return {
      type,
      userId,
      userName,
      userEmail,
    };
  }

  throw new Error(`Unknown type: ${type}`);
};
